var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoutIcon = function SvgLogoutIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 15.601 15.601"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fec968",
    d: "M13.868 15.6H1.733A1.733 1.733 0 0 1 0 13.868V10.4h1.733v3.467h12.135V1.733H1.733V5.2H0V1.733A1.733 1.733 0 0 1 1.733 0h12.135A1.733 1.733 0 0 1 15.6 1.733v12.135a1.733 1.733 0 0 1-1.732 1.732m-6.934-4.332v-2.6H0V6.934h6.934v-2.6L11.268 7.8Z",
    "data-name": "Group 8251"
  })));
};
export default SvgLogoutIcon;